import { render, staticRenderFns } from "./AgentWithdrawInfoAdd.vue?vue&type=template&id=66366720&scoped=true&"
import script from "./AgentWithdrawInfoAdd.vue?vue&type=script&lang=js&"
export * from "./AgentWithdrawInfoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66366720",
  null
  
)

export default component.exports